export default "__VITE_ASSET__fa46779d__"